import React from "react";
import "./StickyBottom.scss";
import variables from "../../common/commonConstant.scss";

const StickyBottom = ({ children, onClick, buttonText, isActive, buttonProps, secondaryButtonProps, secondaryButtonText, secondaryOnClick, secondaryIsActive, customClass = ''
}) => {
  const buttonStyles = {
    backgroundColor: isActive ? variables.black : variables.shadowGrey1,
    color: isActive ? variables.white : variables.gray3,
  };

  const secondaryButtonStyles = {
    backgroundColor: secondaryIsActive ? variables.white : variables.shadowGrey1,
    color: secondaryIsActive ? variables.black : variables.gray3,
  };
  return (
    <div className="sticky-footer">
      {children}
      <div className="sticky-footer-inner">
        {secondaryButtonText && secondaryOnClick ? <button onClick={secondaryOnClick} {...secondaryButtonProps} className="sticky-button" style={{ ...secondaryButtonProps.style, ...secondaryButtonStyles }} disabled={!secondaryIsActive}>{secondaryButtonText}</button>
          : null}
        <button onClick={onClick} {...buttonProps} className={`sticky-button${customClass ? ` ${customClass}` : ''}`} style={{ ...buttonProps.style, ...buttonStyles }} disabled={!isActive}>{buttonText}</button>
      </div>
    </div>
  );
};

export default StickyBottom;